<style lang="scss">
@import '../../assets/scss/_variables';

.result-stat {
    text-align: left;

    .subtitle {
        margin-bottom: 0;
    }

    .content {
        max-width: 20em;

        p {
            margin-bottom: 12px;
            font-family: $font-family-2;
            font-size: 64px;
            font-weight: bold;
            line-height: 0.9;
            color: $color-white;
        }

        i {
            font-style: normal;
            font-weight: $font-weight-2-regular;
        }

        small {
            display: block;
            font-size: 13px;
            color: $color-text-accent-1-darker;
        }
    }

    @include media-smaller('md') {
        .content {
            p {
                margin-bottom: 6px;
                font-size: 48px;
            }
        }
    }
}
</style>

<template>
    <div class="result-stat">
        <h3 class="subtitle">{{ title }}</h3>

        <div class="content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String
        }
    }
};
</script>
